<template>
	<div class="history">
		<h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">历史记录  </h2>
		
		<div class="date-cell">
			<el-date-picker
				  class="year-picker"
				  :picker-options="pickerOptions" 
			      v-model="tYear"
				  value-format="yyyy"
			      type="year"
			      placeholder="选择年份">
			</el-date-picker>
			<el-select v-model="tMonth" class="month-select" placeholder="请选择月份">
			    <el-option
			      v-for="item in tMonthList"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>
			<el-button class="mainland-btn" @click="handleAction">确定</el-button>
		</div>
		
		<el-table
			:data="combo"
			header-row-class-name="qjc-fts-14 qjc-ftw-500"
			header-cell-class-name="combo-header"
			cell-class-name="qjc-fts-14"
			class="combo"
		>
			<el-table-column
				prop="title"
				label=""
				align="center"
				class-name="title qjc-ftw-500"
			>
			</el-table-column>
			<el-table-column
				prop="basic"
				align="center"
				:class-name="item.key =='base'?'basic':item.key =='packageA'?'PLM':item.key =='packageB'?'comorbidity':item.key =='packageC'?'illness':item.key =='packageD'?'health': ''"
				v-for="item in packageList"
				:key="item.id"
			>
				<div slot="header" class="qjc-c-dark" :class="item.key =='base'?'basic':item.key =='packageA'?'PLM':item.key =='packageB'?'comorbidity':item.key =='packageC'?'illness':item.key =='packageD'?'health': ''">
					{{item.name}}
				</div>
				<template slot-scope="scope">
					<span :class="{ 'c-danger': scope.$index == 1}" >{{item.key =='base'? scope.row.basic:item.key =='packageA'?scope.row.PLM:item.key =='packageB'?scope.row.comorbidity:item.key =='packageC'?scope.row.illness:item.key =='packageD'?scope.row.health: ''}}</span>
				</template>
			</el-table-column>
			<!-- <el-table-column
				prop="health100"
				align="center"
				class-name="comorbidity"
			>
				<div slot="header" class="qjc-c-dark comorbidity">
					健康100
				</div>
				<template slot-scope="scope">
					<span :class="{ 'c-danger': scope.$index == 1 && scope.row.basic<500 }" >{{ scope.row.basic }}</span>
				</template>
			</el-table-column> 
			<el-table-column
				prop="health"
				align="center"
				class-name="health"
			>	
				<div slot="header" class="qjc-c-dark">
					自由定制
				</div>
				<el-table-column
					prop="basic"
					align="center"
					:class-name="item.key =='base'?'basic':item.key =='packageA'?'basic': ''"
					v-for="item in packageList"
				>
					<div slot="header" class="qjc-c-dark">
						{{item.name}}
						增值包-
						<br>
						基础体检套餐
					</div>
					<template slot-scope="scope">
						<span :class="{ 'c-danger': scope.$index == 1 && scope.row.basic<500 }" >{{ scope.row.basic }}</span>
					</template>
				</el-table-column>
				
				<el-table-column
					prop="basic"
					align="center"
					class-name="basic"
				>
					<div slot="header" class="qjc-c-dark">
						增值包-
						<br>
						基础体检套餐 
					</div>
					<template slot-scope="scope">
						<span :class="{ 'c-danger': scope.$index == 1 && scope.row.basic<500 }" >{{ scope.row.basic }}</span>
					</template>
				</el-table-column>
				
				<el-table-column
					prop="PLM"
					align="center"
					class-name="PLM">
					<div class="PLM" slot="header">
						增值包-
						<br>
						同族群PLM对比
					</div>
					<template slot-scope="scope">
						<span :class="{ 'c-danger': scope.$index == 1 && scope.row.PLM<500 }">{{ scope.row.PLM }}</span>
					</template>
				</el-table-column>
				
				<el-table-column
					prop="comorbidity"
					align="center"
					class-name="comorbidity">
					<div class="comorbidity" slot="header">
						增值包-共病风险
					</div>
					<template slot-scope="scope">
						<span :class="{ 'c-danger': scope.$index == 1 && scope.row.comorbidity<500 }">{{ scope.row.comorbidity }}</span>
					</template>
				</el-table-column>
				
				<el-table-column
					prop="illness"
					align="center"
					class-name="illness"
				>
					<div class="illness" slot="header">
						增值包-
						<br>
						疾病风险远期预测
					</div>
					<template slot-scope="scope">
						<span :class="{ 'c-danger': scope.$index == 1 && scope.row.illness<500 }">{{ scope.row.illness }}</span>
					</template>
				</el-table-column>
				
				<el-table-column
					prop="health"
					align="center"
					class-name="health">
					<div class="health" slot="header">
						增值包-
						<br>
						健康促进方案
					</div>
					<template slot-scope="scope">
						<span :class="{ 'c-danger': scope.$index == 1 && scope.row.health<500 }">{{ scope.row.health }}</span>
					</template>
				</el-table-column>
				
				
				
			</el-table-column> -->
			
			<!-- <el-table-column
				prop="muying"
				align="center"
				class-name="comorbidity">
				<div class="comorbidity" slot="header">
					母婴
				</div>
				<template slot-scope="scope">
					<span :class="{ 'c-danger': scope.$index == 1 && scope.row.illness<500 }">{{ scope.row.illness }}</span>
				</template>
			</el-table-column> -->
		</el-table>
		<div class="list-date-cell">
			<!-- <el-select v-model="actionValue" class="action-select" placeholder="请选择操作类型">
			    <el-option
			      v-for="item in actionList"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select> -->
			<!-- <el-select v-model="packageValue" class="action-select" placeholder="请选择套餐">
			    <el-option
			      v-for="item in packageSelectList"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select> -->
			<el-date-picker
				  class="year-picker"
				  :picker-options="pickerOptions" 
			      v-model="hYear"
				  value-format="yyyy"
			      type="year"
			      placeholder="选择年份">
			</el-date-picker>
			<el-select v-model="hMonth" class="month-select" placeholder="请选择月份">
			    <el-option
			      v-for="item in hMonthList"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>
			<el-button class="mainland-btn" @click="handleHAction">确定</el-button>
		</div>	
		<el-table
			:data="list"
			class="list qjc-fts-14"
			:fit="true"
			header-cell-class-name="list-header qjc-ftw-500 qjc-c-dark"
		>
			<el-table-column
				prop="version"
				label="操作"
				class-name="operate"
			>
				<template slot-scope="scope">
					<span :class="{ 'c-danger': scope.row.version >1 }">{{ scope.row.version > 1?'修改':'开通' }}</span>
				</template>
			</el-table-column>
			
			<el-table-column
				prop="mobile"
				label="手机号"
				class-name="phone"
			>
				<template slot-scope="scope">
					{{ scope.row.mobile?scope.row.mobile:'--' }}
				</template>
			</el-table-column>
			
			<el-table-column
				prop="yy_user_id"
				label="企业用户ID"
				class-name="userId"
			>
				<template slot-scope="scope">
					{{ scope.row.yy_user_id?scope.row.yy_user_id:'--' }}
				</template>
			</el-table-column>
			
			<el-table-column
				prop="sex"
				label="性别"
				class-name="sex"
			></el-table-column>
			
			<el-table-column
				prop="examdate"
				label="体检日期"
				class-name="examDate"
			></el-table-column>
			<!-- class-name="basic qjc-c-dark" -->
			<el-table-column
				prop="package"
				align="center"
				:class-name="item.key =='base'?'basic':item.key =='packageA'?'PLM':item.key =='packageB'?'comorbidity':item.key =='packageC'?'illness':item.key =='packageD'?'health': ''"
				v-for="item in packageList"
				:key="item.id"
			>
				<div slot="header" >
					{{item.name}}
				</div>
				<template slot-scope="scope">
					<i :class="[ comboStatus(scope, item.key) ]" class="iconfont"></i>
				</template>
			</el-table-column>
			<!-- <el-table-column
				prop="package"
				align="center"
				class-name="basic qjc-c-dark"
			>
				<div slot="header" >
					基础
					<br>
					体检套餐 
				</div>
				<template slot-scope="scope">
					<i :class="scope.row.package.indexOf('base') != -1?'iconduihao iconfont': '']"></i>
				</template>
			</el-table-column>
			
			<el-table-column
				prop="package"
				align="center"
				class-name="PLM"
			>
				<div slot="header">
					增值包-
					<br>
					同族群PLM对比
				</div>
				<template slot-scope="scope">
					<i :class="[ comboStatus(scope, 'packageA') ]" class="iconfont"></i>
				</template>
			</el-table-column>
			
			<el-table-column
				prop="comorbidity"
				align="center"
				class-name="comorbidity"
			>
				<div slot="header">
					增值包-
					<br>
					共病风险
				</div>
				<template slot-scope="scope">
					<i :class="[ comboStatus(scope, 'packageB') ]" class="iconfont"></i>
				</template>
			</el-table-column>
			
			<el-table-column
				prop="illness"
				align="center"
				class-name="illness"
			>
				<div slot="header">
					增值包-
					<br>
					疾病风险远期预测
				</div>
				<template slot-scope="scope">
					<i :class="[ comboStatus(scope, 'packageC') ]" class="iconfont"></i>
				</template>
			</el-table-column>
			
			<el-table-column
				prop="health"
				align="center"
				class-name="health"
			>
				<div slot="header">
					增值包-
					<br>
					健康促进方案
				</div>
				<template slot-scope="scope">
					<i :class="[ comboStatus(scope, 'packageD') ]" class="iconfont"></i>
				</template>
			</el-table-column> -->
			
			<el-table-column
				prop="operator"
				label="操作人"
				class-name="operator"
			>
			</el-table-column>
			
		</el-table>
		
		<el-pagination
			class="pagination qjc-texta-c"
			layout="prev, pager, next"
			hide-on-single-page
			:current-page.sync="pageData.page"
			:page-count="pageData.pagecount"
			:page-size="pageData.pagesize"
			:total="pageData.count"
			@current-change="pageChange"
		></el-pagination>
		
	</div>
</template>

<script>
	import "@/assets/iconfont/iconfont.css";
	import { getHistory, getPackage } from "@/utils/axios.js";
	
	export default{
		name: 'history',
		data() {
			return {
				combo: [
					{ title: '已使用次数', basic: 0, PLM: 0, comorbidity: 0, illness: 0, health: 0 },//累计使用次数
					{ title: '剩余次数', basic: 0, PLM: 0, comorbidity: 0, illness: 0, health: 0 }//剩余次数
				],
				
				list: [],//历史记录列表
				packageList: [],
				pickerOptions: {}, //年份选择范围
				actionList: [
					{
						value: '',
						label: '全部操作'
					},{
						value: 'open',
						label: '开通'
					},{
						value: 'update',
						label: '修改'
					},
				],
				actionValue: '',
				// packageSelectList: [
				// 	{
				// 		value: '',
				// 		label: '全部套餐'
				// 	},
				// 	{
				// 		value: '1',
				// 		label: '健康100'
				// 	},{
				// 		value: '2',
				// 		label: '自由定制'
				// 	},{
				// 		value: '3',
				// 		label: '母婴',
				// 	}
				// ],
				// packageValue: '',
				monthList: [
					{
					  value: '',
					  label: '全年'
					},{
					  value: '1',
					  label: '1月'
					},{
					  value: '2',
					  label: '2月'
					},{
					  value: '3',
					  label: '3月'
					},{
					  value: '4',
					  label: '4月'
					},{
					  value: '5',
					  label: '5月'
					},{
					  value: '6',
					  label: '6月'
					},{
					  value: '7',
					  label: '7月'
					},{
					  value: '8',
					  label: '8月'
					},{
					  value: '9',
					  label: '9月'
					},{
					  value: '10',
					  label: '10月'
					},{
					  value: '11',
					  label: '11月'
					},{
					  value: '12',
					  label: '12月'
					},
				], // 默认月份列表
				tMonthList: [], // 实际套餐使用情况月份列表
				hMonthList: [], // 实际历史记录月份列表
				tYear: '', //套餐使用选中年份
				tMonth: '', //套餐使用选中月份
				hYear: '', //历史记录选中年份
				hMonth: '', //历史记录选中月份
				pageData: {
					count: 0,// 总条数
					page: 1,// 当前页
					pagecount: 0,// 总页数
					pagesize: 12// 每页条数
				}
			}
		},
		created() {
			this.tYear = new Date();
			this.hYear = new Date(); 
			let nowMonth = new Date().getMonth() + 1; //当前月份
			this.tMonth = nowMonth + ''; //默认选中当前月份 
			this.hMonth = nowMonth + ''; //默认选中当前月份 
			this.pickerOptions = {
				disabledDate: 
					(time) => {
					   return (
						   time > new Date()
					   )
					}
			}; // 年份选择范围 不能大于当前年份
			//获取套餐信息
			this.getPackageList(new Date().getFullYear(), new Date().getMonth() + 1);
			//获取历史记录
			this.getHistoryList(1, new Date().getFullYear(), new Date().getMonth() + 1, '');
		},
		mounted() {
			
		},
		watch: {
			// 监听年份变化 改变月份列表
			tYear(newVal, oldVal) {
				let nowYear = new Date().getFullYear();  //当前年份
				let nowMonth = new Date().getMonth() + 1; //当前月份
				let oldYear = typeof oldVal == 'string' ? oldVal : (oldVal instanceof Object ? oldVal.getFullYear() : '') 
				let newYear = typeof newVal == 'string' ? newVal : (newVal instanceof Object ? newVal.getFullYear() : '') // 是否为初始时间 或 清空
				let list = this.monthList
				// 选中当前年份时，月份列表截止当前月份
				if(nowYear == newYear){
					this.tMonthList = list.slice(0, nowMonth + 1)
					if(this.tMonth > nowMonth) {
						this.tMonth = nowMonth + ''
					}
					return
				}else {
					this.tMonthList = list
				}
			},
			hYear(newVal, oldVal) {
				let nowYear = new Date().getFullYear();  //当前年份
				let nowMonth = new Date().getMonth() + 1; //当前月份
				let oldYear = typeof oldVal == 'string' ? oldVal : (oldVal instanceof Object ? oldVal.getFullYear() : '') 
				let newYear = typeof newVal == 'string' ? newVal : (newVal instanceof Object ? newVal.getFullYear() : '') // 是否为初始时间 或 清空
				let list = this.monthList
				// 选中当前年份时，月份列表截止当前月份
				if(nowYear == newYear){
					this.hMonthList = list.slice(0, nowMonth + 1)
					if(this.hMonth > nowMonth) {
						this.hMonth = nowMonth + ''
					}
					return
				}else {
					this.hMonthList = list
				}
			},
		},
		methods: {
			//获取套餐信息
			getPackageList(year, month) {
				getPackage({
					from: 'yy',
					year: year,
					month: month
				}).then((res) => {
					if(res.code == 200){
						let data = JSON.parse(window.atob(res.data))
						// 0下标数据为累计使用次数
						this.combo[0].basic = data.package.base ? data.package.base.used : 0;
						this.combo[0].PLM = data.package.packageA ? data.package.packageA.used : 0;
						this.combo[0].comorbidity = data.package.packageB ? data.package.packageB.used : 0;
						this.combo[0].illness = data.package.packageC ? data.package.packageC.used : 0;
						this.combo[0].health = data.package.packageD ? data.package.packageD.used : 0;
						// 1下标数据为剩余次数
						// 判断是否为预支付还是后付费
						if(data.pay_mode && data.pay_mode == '1') {
							this.combo[1].basic = data.package.base ? data.package.base.times : 0;
							this.combo[1].PLM = data.package.packageA ? data.package.packageA.times : 0;
							this.combo[1].comorbidity = data.package.packageB ? data.package.packageB.times : 0;
							this.combo[1].illness = data.package.packageC ? data.package.packageC.times : 0;
							this.combo[1].health = data.package.packageD ? data.package.packageD.times : 0;
						} else {
							this.combo = this.combo.slice(0, 1)
						}
						// 整合套餐信息
						let death = data.package
						let deathList = []
						let dieList = []
						for (let j in death) {
							deathList.push([death[j],j]);
						}
						deathList.map((item, index) => {
							let arr = item[0]
							arr.key = item[1]
							dieList.push(arr)
						})
						this.packageList = dieList
						
					}else{
						this.$myAlert({
							type: 'fail',
							content: res.msg
						});
					}
				})
			},
			// 获取历史记录数据 
			getHistoryList(page, year, month, act) {
				// page 分页  year 选中年份  month 选中月份  act 操作类型
				getHistory({
					year: year,
					month: month ? month : '',
					page: page || this.pageData.page,
					pagesize: 12,
				}).then(res => {
					if(res.code == 200){
						// 历史记录列表数据
						this.list = res.data.data;
						
						// 分页
						var pager = res.data.pager;
						for(var key in pager){
							pager[key] = parseInt(pager[key]);
						}
						this.pageData = pager;
					}else{
						this.$myAlert({
							type: 'fail',
							content: res.msg
						});
					}
				});
			},
			
			// 历史记录页面切换
			pageChange(page) {
				let years = typeof this.hYear == 'string' ? this.hYear : (this.hYear instanceof Object ? this.hYear.getFullYear() : '');
				this.getHistoryList(page, years, this.hMonth, this.actionValue);
			},
			
			// 套餐状态(有、没有、添加、删除)  参数：1、对应数据   2、对应套餐标识
			comboStatus(scope, packageName) {
				return scope.row.old_package?(scope.row.old_package.indexOf(packageName) != -1?(scope.row.package.indexOf(packageName) != -1?'iconduihao':'delete-icon iconduihao'):(scope.row.package.indexOf(packageName) != -1?'iconduihaobeifen31':'')):(scope.row.package.indexOf(packageName) != -1?'iconduihao':'');
			},
			// 套餐信息筛选
			handleAction() {
				let years = typeof this.tYear == 'string' ? this.tYear : (this.tYear instanceof Object ? this.tYear.getFullYear() : '');
				this.getPackageList(years, this.tMonth)
			},
			// 历史记录筛选
			handleHAction() {
				let years = typeof this.hYear == 'string' ? this.hYear : (this.hYear instanceof Object ? this.hYear.getFullYear() : '');
				this.getHistoryList(1, years, this.hMonth, this.actionValue);
			},
		}
	}
</script>

<style scoped>
	.el-table >>> .PLM{
		color: #C07E37;
	}
	.el-table >>> .comorbidity{
		color: #C92B5C;
	}
	.el-table >>> .illness{
		color: #5843BE;
	}
	.el-table >>> .health{
		color: #1955AF;
	}
	
	.combo >>> .el-table__body tr{
		pointer-events: none;
	}
	.combo >>> td,
	.combo >>> th.is-leaf{
		border: 0.01rem solid #fff;
	}
	.combo >>> .title{
		background-color: #F1F5FC;
	}
	.combo >>> .basic{
		background-color: #F5F9FC;
	}
	.combo >>> .PLM{
		background-color: #FCF9F0;
	}
	.combo >>> .comorbidity{
		background-color: #FCF5F2;
	}
	.combo >>> .illness{
		background-color: #F6F5FC;
	}
	.combo >>> .health{
		background-color: #F0F6FC;
	}
	.combo >>> .combo-header .cell{
		line-height: 18px;
	}
	
	.list >>> .el-table__body, 
	.list >>> .el-table__footer, 
	.list >>> .el-table__header{
		table-layout: auto;
	}
	.list >>> .operate .cell{
		width: 84px;
		padding-left: 16px;
	}
	.list >>> .phone .cell,
	.list >>> .userId .cell{
		width: 127px;
	}
	.list >>> .sex .cell{
		width: 68px;
	}
	.list >>> .examDate .cell{
		width: 120px;
	}
	.list >>> .basic .cell,
	.list >>> .comorbidity .cell,
	.list >>> .illness .cell{
		width: 0.88rem;
	}
	.list >>> .PLM .cell{
		width: 1.04rem;
	}
	.list >>> .health .cell{
		width: 1.16rem;
	}
	.list >>> .operator .cell{
		width: 1.11rem;
	}
	.list >>> .list-header{
		background-color: #FAFBFC;
	}
	.list >>> .list-header .cell{
		line-height: 0.16rem;
	}
	.pagination >>> button{
		width: 0.32rem;
		height: 0.32rem;
		line-height: 0.32rem;
	}
	.pagination >>> button .el-icon{
		font-size: 0.14rem;
	}
	.pagination >>> li{
		width: 0.32rem;
		height: 0.32rem;
		line-height: 0.32rem;
		font-size: 0.14rem;
		font-weight: 400;
		color: #40444D;
		border: 0.01rem solid transparent;
		border-radius: 0.08rem;
		margin: 0 0.06rem;
		padding: 0;
		overflow: visible;
	}
	.pagination >>> li:hover,
	.pagination >>> li.active{
		color: #6681FA;
		font-weight: 600;
		border-color: #6681FA;
		border-left: 0.01rem solid #6681FA;
	}
</style>
<style lang="scss" scoped>
	.history{
		.el-table{
			.c-danger{
				color: #FF4C52;
			}
		}
		.combo{
			color: #777F8F;
			border-radius: 0.24rem 0 0.24rem 0;
			margin-top: 0.12rem;
			margin-bottom: 0.4rem;
		}
		.list{
			color: #777F8F;
			margin-top: 0.12rem;
			
			.iconfont{
				font-size: 0.12rem;
				
				&.delete-icon{
					position: relative;
					color: #777F8F;
					
					&::after{
						position: absolute;
						top: 50%;
						left: 50%;
						width: 100%;
						height: 0.02rem;
						content: '';
						background-color: #FF4C52;
						border-radius: 0.01rem;
						transform: translate(-50%,-50%);
					}
				}
			}
		}
		.pagination{
			margin-top: 0.24rem;
		}
		
		.date-cell {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			margin-top: 0.32rem;
		}
		
		.list-date-cell {
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
		
		.year-picker {
			width: 1.2rem;
			margin-right: 0.1rem;
		}
		
		.month-select {
			width: 1rem;
		}
		
		.mainland-btn {
			width: 0.8rem;
			height: 40px;
			font-size: 0.14rem;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
			background: #6681FA;
			border: none;
			border-radius: 0.04rem;
			margin-left: 0.1rem;
		}
		
		.action-select {
			width: 1.4rem;
			margin-right: 0.1rem;
		}
	}
</style>